import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Button from "../../common/components/Button";
import { toast } from "../../common/components/Toast";
import { SPACING } from "../../common/constants/spacing";

export const SourceSettingsTab = ({
  source,
  deleteSource,
  updateSource,
  updating,
}) => {
  const { t } = useTranslation("sources");
  const [confirmOpen, setConfirmOpen] = useState(false);
  const navigate = useNavigate();

  const handleDelete = async () => {
    try {
      await deleteSource(source.id);
      toast.success(t("settings.deleteSuccess"));
      navigate("/sources");
    } catch (error) {
      toast.error(t("settings.deleteFailed"));
    } finally {
      setConfirmOpen(false);
    }
  };

  const handleToggleStatus = async () => {
    try {
      const newStatus = source.status === "active" ? "paused" : "active";
      const updatedSource = await updateSource({ status: newStatus });
      if (updatedSource) {
        toast.success(
          newStatus === "active"
            ? t("settings.sourceActivated")
            : t("settings.sourcePaused"),
        );
      }
    } catch (error) {
      toast.error(t("settings.updateStatusFailed"));
    }
  };

  return (
    <>
      <Box sx={{ py: 2 }}>
        <Typography variant="h6" sx={{ mb: SPACING.sm, fontWeight: 600 }}>
          {t("settings.sourceActions")}
        </Typography>
        <Box display="flex" gap={2} flexWrap="wrap">
          <Button
            variant="outlined"
            color={source.status === "active" ? "warning" : "success"}
            onClick={handleToggleStatus}
            disabled={updating}
          >
            {updating
              ? t("settings.updating")
              : source.status === "active"
                ? t("settings.pauseSource")
                : t("settings.activateSource")}
          </Button>
          <Button
            variant="outlined"
            color="error"
            onClick={() => setConfirmOpen(true)}
          >
            {t("settings.deleteSource")}
          </Button>
        </Box>
      </Box>

      {/* Delete confirmation dialog */}
      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogContent>
          <Typography variant="h4">{t("settings.confirmDeletion")}</Typography>
          <Typography sx={{ py: 3 }}>{t("settings.deleteWarning")}</Typography>
          <DialogActions>
            <Button onClick={() => setConfirmOpen(false)}>
              {t("settings.cancel")}
            </Button>
            <Button onClick={handleDelete} color="error" variant="contained">
              {t("settings.delete")}
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </>
  );
};
